import Header from "../header/Header";
import DashboardLayout from "../layout";
import { useState } from "react";
import PersonalTodos from "./PersonalTodos";
import AssignedTodos from "./AssignedTodos";
import AddTodoModal from "./AddTodoModal";
import { useMyContext } from "../../context/MyContext";
import SuperAdminTodos from "./SuperAdminTodos";

const ToDo = () => {
  const { user } = useMyContext();
  const [active, setActive] = useState("Personal Todos");
  const [openModal, setOpenModal] = useState(false);
  const tabs = ["Personal Todos", "Assigned Todos"];

  return (
    <>
      <DashboardLayout>
        <div className="w-full">
          <Header title="ToDos" />

          <div className="p-5 felx flex-col space-y-2">
            <div className="w-full flex items-center justify-between">
              {user?.role === "super admin" ? null : (
                <div className="py-3 px-3 shadow-md flex flex-wrap justify-between gap-2 w-[30%] rounded-xl bg-white">
                  {tabs?.map((e) => (
                    <button
                      key={e}
                      onClick={() => setActive(e)}
                      className={`${active === e ? "btnBg text-white" : ""
                        } text-sm text-black rounded-md text-center py-3 block md:w-[45%] btnHover hover:text-white transition-colors duration-300`}
                    >
                      {e}
                    </button>
                  ))}
                </div>
              )}
              {user?.role === "super admin" ? (
                <button
                  className={`btnBg text-white text-sm rounded-md text-center py-3 block btnHover hover:text-white transition-colors duration-300 px-4`}
                  onClick={() => setOpenModal(true)}
                >
                  Add Todo
                </button>
              ) : null}
            </div>
            {user?.role === "super admin" ? (
              <SuperAdminTodos />
            ) : (
              <div className="mt-5">
                {active === "Personal Todos" && <PersonalTodos />}
                {active === "Assigned Todos" && <AssignedTodos />}
              </div>
            )}
          </div>
        </div>
        {openModal && (
          <AddTodoModal setOpenModal={setOpenModal} openModal={openModal} />
        )}
      </DashboardLayout>
    </>
  );
};

export default ToDo;